import { useEffect, useState } from 'react';

/** Scroll depth (px) after which the button appears. */
const SHOW_AFTER_PX = 600;

/**
 * Floating "Back to Top" pill (Figma 5751-141388): fixed above the bottom
 * nav on the right, appears once the lobby is scrolled past
 * {@link SHOW_AFTER_PX}, and smooth-scrolls the window back to the top.
 */
export function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > SHOW_AFTER_PX);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-[calc(102px+env(safe-area-inset-bottom))] right-2.5 z-40 flex h-10 items-center justify-center rounded-[46px] border border-solid border-stroke-soft bg-surface px-4 shadow-[0px_0px_4px_0px_var(--stroke-soft)] md:bottom-8 md:right-8"
    >
      <span className="text-[16px] font-semibold tracking-[-0.32px] text-ink">Back to Top</span>
    </button>
  );
}
